import type { UIEvent } from "react"

import { useRef } from "react"

const useDataViewTableScroll = () => {
  const tableHeadRef = useRef<HTMLTableSectionElement | null>(null)

  const onBodyScroll = (event: UIEvent<HTMLTableSectionElement>) => {
    if (tableHeadRef.current) tableHeadRef.current.scrollLeft = event.currentTarget.scrollLeft
  }

  return { onBodyScroll, tableHeadRef }
}

export default useDataViewTableScroll
